import { createFileRoute } from '@tanstack/react-router';

import { MeetingPanel } from '../../features/meeting/meeting-panel';

/**
 * `/mylab/meeting` — S5 랩미팅 (E14 §2)
 *
 * 라우트는 얇게 둔다: 화면은 `features/meeting`에 있다. 게이트는 부모 `mylab.tsx`가 맡는다.
 * 선택된 지난 회의는 `meetingId` search param에 담는다 — E14 §3의 인접 상세 규약과 같은
 * 형태(뒤로 가기로 복원, 내비게이션 링크는 실어보내지 않음). `resumeMeetingId`는 별개
 * param이다 — 마지막 활동 재개 링크(`AC-ML-01-06`)가 회의 상태와 무관하게 그 회의의 작업
 * 영역을 직접 연다(`meetingId`는 읽기 전용 상세만 열어 편집 화면에 닿지 않는다).
 */
interface MeetingSearch {
  meetingId?: string;
  resumeMeetingId?: string;
}

export const Route = createFileRoute('/mylab/meeting')({
  validateSearch: (search: Record<string, unknown>): MeetingSearch => ({
    meetingId: typeof search.meetingId === 'string' ? search.meetingId : undefined,
    resumeMeetingId:
      typeof search.resumeMeetingId === 'string' ? search.resumeMeetingId : undefined,
  }),
  component: MeetingScreen,
});

function MeetingScreen() {
  const navigate = Route.useNavigate();
  const { meetingId, resumeMeetingId } = Route.useSearch();

  return (
    <MeetingPanel
      selectedMeetingId={meetingId}
      targetMeetingId={resumeMeetingId}
      onSelectMeeting={(id) => navigate({ search: { meetingId: id }, replace: true })}
    />
  );
}
